<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        :md="hasSidebar ? 8 : 12"
      >
        <material-card
          :color="color"
          :icon="icon"
          :icon-small="small"
          :icon-color="iconColor"    
          :loading="loading"        
          style="position: relative;"        
          progress-color="white"
        >
          <template #title>
            <v-card 
              flat              
              style="position: sticky; top: 0;align-self: flex-start"
            >
              <slot name="title" />
              <v-card-actions
                class="pr-12"
              >
                <!-- <v-spacer /> -->
                <slot name="actions" />
              </v-card-actions>
            </v-card>
          </template>
          <slot />
        </material-card>
      </v-col>
      <v-col
        v-if="hasSidebar"
        cols="12"
        md="4"
      >
        <div class="d-none d-md-flex">
          <slot name="sidebar" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  export default {
    name: 'InfinityPage',
    props: {
      icon: String,
      iconColor: {
        type: String,
        default: () => 'white',
      },
      color: {
        type: String,
        default: () => 'primary',
      },
      small: {
        type: Boolean,
        default: () => false,
      },
      loading: {
        type: Boolean,
        default: () => false,
      },
    },
    computed: {
      hasSidebar () {
        return !!this.$slots.sidebar
      },
    },
  }
</script>
